import React from "react"


import Layout from "../components/layout"
import { CardSet, Card } from "../components/cardset"
import Brand from "../components/brand"
import Splash from "../components/splash"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <div css={theme => ({
      maxWidth: theme.center_width_percent + '%',
      margin: '0 auto',
      })}
    >
      <SEO title="Home" keywords={[`meshsem`, `marketing`, `marketing research`, `messaging`, `strategy`, `survey`, `community`, `interview`, `secret shopping`, `brand research`, `tampa`, `st. petersburg`, `saint petersburg`, `st. pete`, `Florida`]} />
      <p><span style={{ color: `#CD5828` }}>Meshsem, Inc.</span> is a research consultancy based in St. Petersburg, Florida. The firm focuses on making data-driven decision-making a reality, collaborating with marketing firms, private companies and public entities, to ensure big decisions are made thoughtfully, and are backed by quantitative and qualitative insight.</p>
      <p>Why the name <span style={{ color: `#CD5828` }}>Meshsem</span>? In a mesh network, information is reliably relayed as a result of a dynamic and cooperative framework. Similarly, the most effective and actionable research stems from deep-seated cooperation.</p>
      <p>Whether governed by a board, a CEO or a community, all organizations benefit from thoughtful research that engages multiple mediums, audiences and stakeholders. <span style={{ color: `#CD5828` }}>Meshsem</span> looks at your needs from every angle and develops a plan to capture the insights you seek.</p>
      <p css={{marginBottom: `0` }}><a href="mailto:contactus@meshsem.com">Contact us</a> to find out how we can help you tell your story through data.</p>
      <CardSet>
        <Card title="Who We Serve">
          <ul>
            <li>Communities</li>
            <li>Candidates</li>
            <li>Corporations</li>
          </ul>
        </Card>
        <Card title="Types of Research">
          <ul>
            <li>Employee Engagement</li>
            <li>Customer Satisfaction</li>
            <li>Stakeholder Sentiments</li>
            <li>Needs Assessments</li>
            <li>Brand Awareness</li>
            <li>Brand Equity</li>
            <li>Economic Impact</li>
          </ul>
        </Card>
        <Card title="Mediums">
          <ul>
            <li>Online Survey</li>
            <li>Phone Survey</li>
            <li>Direct Mail Survey</li>
            <li>Focus Group</li>
            <li>Secret Shopping</li>
            <li>Data Mining</li>
          </ul>
        </Card>
      </CardSet>
      <p css={{marginBottom: `0` }}>Reach out to us for a <strong>free</strong> 30 minute consultation:</p>
      <p><a href="mailto:contactus@meshsem.com">contactus@meshsem.com</a></p>
    </div>
  </Layout>
)

export default IndexPage
